export default import.meta.ROLLDOWN_FILE_URL_Z$x3SstJoGbuPb7g6pBevQ